/**
 * 지부 코드와 지부명 매핑 데이터
 * JOIN_URLS.md 기반
 */
export const jibuMapping = {
    '107108': '서울지부',
    '108108': '인천지부',
    '109108': '안산지부',
    '110108': '경기1지부',
    '111108': '경기2지부',
    '112108': '경기3지부',
    '113108': '안성지부',
    '114108': '양주지부',
    '115108': '고양파주지부',
    '116108': '포천지부',
    '117108': '천안지부',
    '118108': '당진지부',
    '119108': '음성진천지부',
    '120108': '충주제천지부',
    '121108': '청주지부',
    '122108': '대전지부',
    '123108': '포항지부',
    '124108': '경북지부',
    '125108': '대구지부',
    '126108': '경남1지부',
    '127108': '경남2지부',
    '128108': '울산지부',
    '129108': '부산지부',
    '130108': '광주지부',
    '131108': '전남1지부',
    '132108': '전남2지부',
    '133108': '전북지부',
    '134108': '도우물류',
    '135108': '이사대학',
    '136108': 'LTL TAX',
    '137108': '대구중소형지부',
    '138108': '월드로지스',
    '139108': '장원물류',
    '140108': '에스엠로지텍',
    '141108': '카리스로지스',
    '142108': '하이한마음',
    '143108': '태영윈',
    '145108': '조일물류',
};

/**
 * 지부 코드로 지부명 조회
 * @param {string|number} jibuCode - 지부 코드 (예: '107108', 107108)
 * @returns {string|null} 지부명 또는 null
 */
export function getJibuName(jibuCode) {
    return jibuMapping[String(jibuCode)] || null;
}